<template>
  <v-container>
    <v-layout column>
      <v-flex xs12>
        <h1 class="display-1 mb-5 text-xs-center">Login</h1>
        <form novalidate @submit.prevent="whenValid(onSubmit)">
          <v-text-field
            v-model="form.email"
            v-validate="'required|email'"
            :error-messages="errors.collect('email')"
            label="E-mail"
            type="email"
            data-vv-name="email"
            required
            autofocus
          >
          </v-text-field>
          <v-text-field
            v-model="form.password"
            v-validate="'required|min:6'"
            :error-messages="errors.collect('password')"
            label="Password"
            type="password"
            data-vv-name="password"
            required
          >
          </v-text-field>
          <v-layout align-center justify-space-between row fill-height>
            <v-btn
              :disabled="errors.any() || !isComplete"
              large
              color="success"
              type="submit"
              class="mt-3"
            >
              Login
            </v-btn>
            <router-link :to="{ name: 'password.request' }">
              Reset Password
            </router-link>
          </v-layout>
          <v-alert
            v-if="authError"
            :value="authError"
            color="error"
            icon="fas fa-exclamation-triangle"
            outline
            class="mt-3"
          >
            {{ authError }}
          </v-alert>
        </form>
      </v-flex>
      <v-flex xs12>
        <p class="text-xs-center mt-3">
          &#42;&#42; If you haven't previously registered for our site, please
          <router-link to="register">register</router-link>
        </p>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import validate from '../../mixins/validate';
import { login } from '../../api/auth';
import { lowercase } from '../../utils/filters';

export default {
  name: 'Login',
  mixins: [validate],
  $_veeValidate: {
    validator: 'new',
  },
  metaInfo: {
    title: 'Login',
  },
  data() {
    return {
      form: {
        email: lowercase(''),
        password: '',
      },
      error: null,
      dictionary: {
        attributes: {
          email: 'E-mail Address',
          password: 'Password',
        },
        custom: {
          password: {
            min: 'A minimum of 8 characters are required',
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      authError: 'authError',
    }),
    isComplete() {
      return !!(this.form.email && this.form.password);
    },
  },
  mounted() {
    this.$validator.localize('en', this.dictionary);
  },
  methods: {
    ...mapMutations(['showSnackbar', 'closeSnackbar']),
    onSubmit() {
      this.$store.dispatch('login');
      login(this.$data.form)
        .then((res) => {
          this.$store.commit('loginSuccess', res);
          this.clear();
          this.loginSuccess();
        })
        .then(() => this.$router.push({ path: '/' }))
        .catch((error) => {
          this.$store.commit('loginFailed', { error });
          this.loginFailed();
        });
    },
    loginSuccess() {
      this.showSnackbar({
        text: 'You successfully logged in!',
        color: 'success',
        timeout: 5000,
      });
    },
    loginFailed() {
      this.showSnackbar({
        text: 'There was a problem with your login credentials!',
        color: 'warning',
        timeout: 5000,
      });
    },
    clear() {
      this.form.email = '';
      this.form.password = '';
      this.$validator.reset();
    },
  },
};
</script>

<style scoped>
form {
  max-width: 500px;
  margin: 0 auto;
}
</style>
